const dummyData = {
  communities: [
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
    {
      name: 'r/TooAfraidToAsk',
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
    },
  ],

  searchItems: [
    {
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
      name: 'r/AskReddit',
      memberCount: '43.6m',
    },
    {
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
      name: 'r/AskReddit',
      memberCount: '43.6m',
    },
    {
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
      name: 'r/AskReddit',
      memberCount: '43.6m',
    },
    {
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
      name: 'r/AskReddit',
      memberCount: '43.6m',
    },
    {
      src: 'https://styles.redditmedia.com/t5_2vpba/styles/communityIcon_wljyl0was6q01.png',
      name: 'r/AskReddit',
      memberCount: '43.6m',
    },
  ],

  posts: [
    {
      userImgSource:
        'https://styles.redditmedia.com/t5_2tk0s/styles/communityIcon_v5b469kmb68b1.png?width=256&s=73d117baa4756f1cf092c67446f013bdf5c9bf32',
      upvotes: 468,
      subredditName: 'r/UnpopularOpinion',
      subredditLink: '/r/UnpopularOpinion',
      title: 'Lorem Ipsum Dolor Sit Amet.',
      content:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
      userName: 'u/JohnDoe',
      commentCount: 48,
      postTime: '2 hours ago',
    },
    {
      userImgSource:
        'https://styles.redditmedia.com/t5_2tk0s/styles/communityIcon_v5b469kmb68b1.png?width=256&s=73d117baa4756f1cf092c67446f013bdf5c9bf32',
      upvotes: 468,
      subredditName: 'r/UnpopularOpinion',
      subredditLink: '/r/UnpopularOpinion',
      title: 'Lorem Ipsum Dolor Sit Amet.',
      content:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
      userName: 'u/JohnDoe',
      commentCount: 48,
      postTime: '2 hours ago',
    },
    {
      userImgSource:
        'https://styles.redditmedia.com/t5_2tk0s/styles/communityIcon_v5b469kmb68b1.png?width=256&s=73d117baa4756f1cf092c67446f013bdf5c9bf32',
      upvotes: 468,
      subredditName: 'r/UnpopularOpinion',
      subredditLink: '/r/UnpopularOpinion',
      title: 'Lorem Ipsum Dolor Sit Amet.',
      content:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
      userName: 'u/JohnDoe',
      commentCount: 48,
      postTime: '2 hours ago',
    },
    {
      userImgSource:
        'https://styles.redditmedia.com/t5_2tk0s/styles/communityIcon_v5b469kmb68b1.png?width=256&s=73d117baa4756f1cf092c67446f013bdf5c9bf32',
      upvotes: 468,
      subredditName: 'r/UnpopularOpinion',
      subredditLink: '/r/UnpopularOpinion',
      title: 'Lorem Ipsum Dolor Sit Amet.',
      content:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
      userName: 'u/JohnDoe',
      commentCount: 48,
      postTime: '2 hours ago',
    },
    {
      userImgSource:
        'https://styles.redditmedia.com/t5_2tk0s/styles/communityIcon_v5b469kmb68b1.png?width=256&s=73d117baa4756f1cf092c67446f013bdf5c9bf32',
      upvotes: 468,
      subredditName: 'r/UnpopularOpinion',
      subredditLink: '/r/UnpopularOpinion',
      title: 'Lorem Ipsum Dolor Sit Amet.',
      content:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
      userName: 'u/JohnDoe',
      commentCount: 48,
      postTime: '2 hours ago',
    },
    {
      userImgSource:
        'https://styles.redditmedia.com/t5_2tk0s/styles/communityIcon_v5b469kmb68b1.png?width=256&s=73d117baa4756f1cf092c67446f013bdf5c9bf32',
      upvotes: 468,
      subredditName: 'r/UnpopularOpinion',
      subredditLink: '/r/UnpopularOpinion',
      title: 'Lorem Ipsum Dolor Sit Amet.',
      content:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
      userName: 'u/JohnDoe',
      commentCount: 48,
      postTime: '2 hours ago',
    },
    {
      userImgSource:
        'https://styles.redditmedia.com/t5_2tk0s/styles/communityIcon_v5b469kmb68b1.png?width=256&s=73d117baa4756f1cf092c67446f013bdf5c9bf32',
      upvotes: 468,
      subredditName: 'r/UnpopularOpinion',
      subredditLink: '/r/UnpopularOpinion',
      title: 'Lorem Ipsum Dolor Sit Amet.',
      content:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
      userName: 'u/JohnDoe',
      commentCount: 48,
      postTime: '2 hours ago',
    },
    {
      userImgSource:
        'https://styles.redditmedia.com/t5_2tk0s/styles/communityIcon_v5b469kmb68b1.png?width=256&s=73d117baa4756f1cf092c67446f013bdf5c9bf32',
      upvotes: 468,
      subredditName: 'r/UnpopularOpinion',
      subredditLink: '/r/UnpopularOpinion',
      title: 'Lorem Ipsum Dolor Sit Amet.',
      content:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
      userName: 'u/JohnDoe',
      commentCount: 48,
      postTime: '2 hours ago',
    },
    {
      userImgSource:
        'https://styles.redditmedia.com/t5_2tk0s/styles/communityIcon_v5b469kmb68b1.png?width=256&s=73d117baa4756f1cf092c67446f013bdf5c9bf32',
      upvotes: 468,
      subredditName: 'r/UnpopularOpinion',
      subredditLink: '/r/UnpopularOpinion',
      title: 'Lorem Ipsum Dolor Sit Amet.',
      content:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
      userName: 'u/JohnDoe',
      commentCount: 48,
      postTime: '2 hours ago',
    },
    {
      userImgSource:
        'https://styles.redditmedia.com/t5_2tk0s/styles/communityIcon_v5b469kmb68b1.png?width=256&s=73d117baa4756f1cf092c67446f013bdf5c9bf32',
      upvotes: 468,
      subredditName: 'r/UnpopularOpinion',
      subredditLink: '/r/UnpopularOpinion',
      title: 'Lorem Ipsum Dolor Sit Amet.',
      content:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
      userName: 'u/JohnDoe',
      commentCount: 48,
      postTime: '2 hours ago',
    },
    {
      userImgSource:
        'https://styles.redditmedia.com/t5_2tk0s/styles/communityIcon_v5b469kmb68b1.png?width=256&s=73d117baa4756f1cf092c67446f013bdf5c9bf32',
      upvotes: 468,
      subredditName: 'r/UnpopularOpinion',
      subredditLink: '/r/UnpopularOpinion',
      title: 'Lorem Ipsum Dolor Sit Amet.',
      content:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
      userName: 'u/JohnDoe',
      commentCount: 48,
      postTime: '2 hours ago',
    },
    {
      userImgSource:
        'https://styles.redditmedia.com/t5_2tk0s/styles/communityIcon_v5b469kmb68b1.png?width=256&s=73d117baa4756f1cf092c67446f013bdf5c9bf32',
      upvotes: 468,
      subredditName: 'r/UnpopularOpinion',
      subredditLink: '/r/UnpopularOpinion',
      title: 'Lorem Ipsum Dolor Sit Amet.',
      content:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
      userName: 'u/JohnDoe',
      commentCount: 48,
      postTime: '2 hours ago',
    },
    {
      userImgSource:
        'https://styles.redditmedia.com/t5_2tk0s/styles/communityIcon_v5b469kmb68b1.png?width=256&s=73d117baa4756f1cf092c67446f013bdf5c9bf32',
      upvotes: 468,
      subredditName: 'r/UnpopularOpinion',
      subredditLink: '/r/UnpopularOpinion',
      title: 'Lorem Ipsum Dolor Sit Amet.',
      content:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
      userName: 'u/JohnDoe',
      commentCount: 48,
      postTime: '2 hours ago',
    },
  ],
};

export default dummyData;
